const numberFormat = new Intl.NumberFormat();

export const getFormatNumberString = (value: number): string => (isNaN(value) ? value.toString() ?? '' : numberFormat.format(value));
